export const PERMS = {
    READ: 'addresses.read',
    UPDATE: 'addresses.update',
    DELETE: 'addresses.delete',
    RESTORE: 'addresses.restore',
    CREATE: 'addresses.create',
    EXPORT: 'addresses.export',
}
